// Deterministic Monitoring outcome search. The only searchable value is the server-authored visible title:
// run/session/task ids, terminal reasons, capability names and model text are deliberately outside this helper.

import type { MonitoringRunOutcomeView } from './operate-projections.ts';

/** Matches the server's visible-title bound; longer direct/programmatic queries fail closed. */
export const MONITORING_OUTCOME_SEARCH_LIMIT = 160;

/** Filter the bounded result window by an available visible title only. */
export function searchMonitoringOutcomes(
  rows: readonly MonitoringRunOutcomeView[],
  query: string,
): readonly MonitoringRunOutcomeView[] {
  const collapsed = query.replace(/\s+/gu, ' ').trim();
  if ([...collapsed].length > MONITORING_OUTCOME_SEARCH_LIMIT) return [];
  if (collapsed.length === 0) return rows;
  const needle = collapsed.toLocaleLowerCase('en-GB');
  return rows.filter(
    (row) => row.title.available && row.title.title.toLocaleLowerCase('en-GB').includes(needle),
  );
}
